import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function CheckedValidator(isChecked: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        //if (control.value != undefined && control.enabled && control.touched && control.value !== isChecked)
        if (control.enable && control.value !== isChecked)
            return { 'checked': true };
        return null;
    };
}

export const hasCheckedValidator = (abstractControl: AbstractControl): boolean => {
    if (abstractControl.validator) {
        const errors: ValidationErrors = abstractControl.validator({} as AbstractControl);
        if (errors && errors.checked) {
            return true;
        }
    }
    if (abstractControl['controls']) {
        for (const controlName in abstractControl['controls']) {
            if (abstractControl['controls'][controlName]) {
                if (hasCheckedValidator(abstractControl['controls'][controlName])) {
                    return true;
                }
            }
        }
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/app/services/checked-validator.ts